module.exports = __webpack_public_path__ + "img/gongzhonghao.a3c591e6.jpg";